export default "__VITE_ASSET__DkXWFcgp__"